// System
import { Suspense, useMemo } from 'react';
import { Tabs, Tab, Box, CircularProgress, Divider } from '@mui/material';

// Features
import { ProviderList } from '@Features/provider/ProvidersList';
import { ProvidersTitle } from '@Features/provider/ProvidersTitle/ProvidersTitle';
import { ConfigList } from '@Features/provider/ConfigList';
import { ConfigsTitle } from '@Features/provider/ConfigsTitle';
import { useProvidersTable } from '@Modal/hooks/providers/useProvidersTable';
// import { GameVersionsTitle } from '@Features/provider/GameVersionsTitle/GameVersionsTitle';
// import { GameVersionsList } from '@Features/provider/GameVersionsList/GameVersionsList';

const panels = [ProviderList, ConfigList];
const titles = [ProvidersTitle, ConfigsTitle];

export const ProvidersPage = () => {
  const { currentTab, handleTabChange } = useProvidersTable();
  const Component = useMemo(() => panels[currentTab], [currentTab]);
  const Title = useMemo(() => titles[currentTab], [currentTab]);

  return (
    <>
      <Title />
      <Tabs value={currentTab}>
        <Tab label="Casinos" onClick={() => handleTabChange(0)} />
        <Tab label="Configurations" onClick={() => handleTabChange(1)} />
        {/* <Tab label="Game Versions" onClick={() => handleTabChange(2)} /> */}
      </Tabs>
      <Divider />
      <Box sx={{ paddingTop: 3, paddingBottom: 2 }}>
        <Suspense fallback={<CircularProgress />}>
          <Component />
        </Suspense>
      </Box>
    </>
  );
};
